module.exports = __webpack_public_path__ + "img/plus-minus.f7663654.svg";